var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ConfigurationService } from '../configuration.service';
import { SerializationService } from '../serialization.service';
import { AnimationService } from '../animation.service';
import { ModelService } from '../model.service';
import { ThreeService } from '../three.service';
import { BackendService } from '../backend.service';
var ViewerComponent = /** @class */ (function () {
    function ViewerComponent(configurationService, serializationService, animationService, threeService, modelService, route, router, location, backendService) {
        this.configurationService = configurationService;
        this.serializationService = serializationService;
        this.animationService = animationService;
        this.threeService = threeService;
        this.modelService = modelService;
        this.route = route;
        this.router = router;
        this.location = location;
        this.backendService = backendService;
        this.mywindow = window;
        window.renderingDone = false;
        window.services = {
            three: threeService,
            backend: this.backendService
        };
    }
    ViewerComponent.prototype.resize = function () {
        this.threeService.resize();
    };
    ViewerComponent.prototype.serialize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var canvas, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.productId) return [3 /*break*/, 2];
                        canvas = this.threeService.screenshot();
                        _a = this;
                        return [4 /*yield*/, this.serializationService.serialize(this.serializationId, canvas)];
                    case 1:
                        _a.serializationId = _b.sent();
                        if (this.configurationService.language.code) {
                            this.location.go(this.configurationService.language.code + "/viewer/" + this.productId + "/" + this.serializationId);
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ViewerComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.modelUrl = localStorage.getItem('modelUrl');
                if (this.modelUrl == null) {
                    this.modelUrl = '';
                }
                this.route.paramMap.subscribe(function (param) { return __awaiter(_this, void 0, void 0, function () {
                    var _this = this;
                    var id;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (param.has('product')) {
                                    id = param.get('product');
                                    setInterval(function () {
                                        _this.serialize();
                                    }, 5000);
                                }
                                else {
                                    window.debug = true;
                                }
                                if (param.has('uuid')) {
                                    this.serializationId = param.get('uuid');
                                    this.serializationService.serializationId = this.serializationId;
                                }
                                this.threeService.domElement = this.canvasContainer.nativeElement;
                                return [4 /*yield*/, this.load(id)];
                            case 1:
                                _a.sent();
                                this.animationService.init();
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    ViewerComponent.prototype.load = function (product) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(product === undefined)) return [3 /*break*/, 2];
                        localStorage.setItem('modelUrl', this.modelUrl);
                        return [4 /*yield*/, this.configurationService._dev_load(this.modelUrl)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 2:
                        _a.trys.push([2, 7, , 8]);
                        if (!(this.productId !== product)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.serializationService.deserialize(this.serializationId, true)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.configurationService.load(product)];
                    case 4:
                        _a.sent();
                        this.productId = product;
                        return [4 /*yield*/, this.serializationService.deserialize(this.serializationId)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        e_1 = _a.sent();
                        console.error('Error loading product');
                        console.error(e_1);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    return ViewerComponent;
}());
export { ViewerComponent };
